import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "@flat-ui";
import { CompanyAvatar } from "@components/common/company-avatar";
import { Box } from "@mui-wrapper";
import { DEFAULT_INPUT_FONT_SIZE, withEllipsis } from "@styles/common-styles";
import { formatUserRoleType } from "@utils/data-display";
import { PALETTE_VARS } from "@styles/palette-vars";
export const LINK_HEIGHT = "70px";

/**
 * Shows a the link for a workspace to be selected in the workspaces selection page.
 */
export function SelectWorkspaceLink(t0) {
  const $ = _c(24);
  const {
    sdbCompany,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "background.paper",
      height: LINK_HEIGHT,
      paddingX: "20px",
      borderRadius: "4px",
      textDecoration: "none",
      color: "inherit",
      "&:hover": {
        boxShadow: `0 0 0 1px ${PALETTE_VARS.primary.main}`,
        cursor: "pointer"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      ...withEllipsis
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "32px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = sdbCompany.type === "admin" ? PALETTE_VARS.common.black : PALETTE_VARS.primary.main;
  let t5;
  if ($[3] !== sdbCompany.name || $[4] !== t4) {
    t5 = <Box component="div" sx={t3}><CompanyAvatar name={sdbCompany.name} color={t4} size="x-large" /></Box>;
    $[3] = sdbCompany.name;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== sdbCompany.name) {
    t6 = <var>{sdbCompany.name}</var>;
    $[6] = sdbCompany.name;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      ...withEllipsis,
      marginX: "20px",
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      fontWeight: "500"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== sdbCompany.name) {
    t8 = <var>{sdbCompany.name}</var>;
    $[9] = sdbCompany.name;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <Tooltip component="div" title={t6} sx={t7}>{t8}</Tooltip>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t5 || $[15] !== t9) {
    t10 = <Box component="div" sx={t2}>{t5}{t9}</Box>;
    $[14] = t5;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== sdbCompany.role.company) {
    t11 = sdbCompany.role.company && <Box component="div" sx={{
      fontSize: DEFAULT_INPUT_FONT_SIZE
    }}>{formatUserRoleType(sdbCompany.role.company) ?? ""}</Box>;
    $[17] = sdbCompany.role.company;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== onClick || $[20] !== sdbCompany.url || $[21] !== t10 || $[22] !== t11) {
    t12 = <Box component="a" href={sdbCompany.url} sx={t1} onClick={onClick}>{t10}{t11}</Box>;
    $[19] = onClick;
    $[20] = sdbCompany.url;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}